(() => {
  const SELECTORS = {
    nav: '[data-ss-nav-v2]',
    item: '[data-ss-nav-item]',
    trigger: '[data-ss-nav-trigger]',
    mobile: '[data-ss-nav-mobile]'
  };

  const closeDesktopNav = (nav, returnFocus = false) => {
    nav.querySelectorAll(SELECTORS.item).forEach((item) => {
      const trigger = item.querySelector(SELECTORS.trigger);
      if (!trigger) return;
      const wasOpen = item.classList.contains('is-open');
      item.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      if (returnFocus && wasOpen) trigger.focus();
    });
  };

  const initDesktop = (nav) => {
    if (nav.dataset.ssNavReady === 'true') return;
    nav.dataset.ssNavReady = 'true';

    let closeTimer;

    const openItem = (item, trigger) => {
      window.clearTimeout(closeTimer);
      closeDesktopNav(nav);
      item.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    };

    nav.querySelectorAll(SELECTORS.item).forEach((item) => {
      const trigger = item.querySelector(SELECTORS.trigger);
      if (!trigger) return;

      item.addEventListener('mouseenter', () => openItem(item, trigger));
      item.addEventListener('mouseleave', () => {
        closeTimer = window.setTimeout(() => closeDesktopNav(nav), 120);
      });

      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        openItem(item, trigger);
      });
    });

    document.addEventListener('pointerdown', (event) => {
      if (!nav.contains(event.target)) closeDesktopNav(nav);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDesktopNav(nav, true);
    });
  };

  const syncMobileLock = () => {
    const anyOpen = [...document.querySelectorAll(SELECTORS.mobile)].some((drawer) => drawer.open);
    document.documentElement.classList.toggle('ss-nav-v2-lock', anyOpen);
  };

  const getHeaderBottom = () => {
    const header = document.querySelector('#header-group') || document.querySelector('header-component');
    if (!header) return 0;
    const rect = header.getBoundingClientRect();
    return Math.max(0, Math.min(window.innerHeight, rect.bottom));
  };

  const mountMobilePanel = (drawer) => {
    const panel = drawer._ssMobilePanel;
    if (!panel) return;

    panel.style.setProperty('--ss-mobile-menu-top', `${getHeaderBottom()}px`);
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.appendChild(panel);
  };

  const restoreMobilePanel = (drawer) => {
    const panel = drawer._ssMobilePanel;
    if (!panel) return;

    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    panel.style.removeProperty('--ss-mobile-menu-top');
    drawer.appendChild(panel);
  };

  const initMobile = (drawer) => {
    if (drawer.dataset.ssNavReady === 'true') return;
    drawer.dataset.ssNavReady = 'true';

    drawer._ssMobilePanel = drawer.querySelector('.ss-nav-mobile__panel');
    if (drawer._ssMobilePanel) drawer._ssMobilePanel.setAttribute('aria-hidden', 'true');

    drawer.addEventListener('toggle', () => {
      if (drawer.open) {
        mountMobilePanel(drawer);
      } else {
        restoreMobilePanel(drawer);
      }
      syncMobileLock();
    });
    drawer.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        drawer.open = false;
        restoreMobilePanel(drawer);
        syncMobileLock();
      });
    });
  };

  const init = (root = document) => {
    root.querySelectorAll(SELECTORS.nav).forEach(initDesktop);
    root.querySelectorAll(SELECTORS.mobile).forEach(initMobile);
  };

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll(SELECTORS.mobile).forEach((drawer) => { drawer.open = false; });
    syncMobileLock();
  });

  window.addEventListener('resize', () => {
    if (window.matchMedia('(min-width: 990px)').matches) {
      document.querySelectorAll(SELECTORS.mobile).forEach((drawer) => {
        drawer.open = false;
        restoreMobilePanel(drawer);
      });
      syncMobileLock();
      return;
    }

    document.querySelectorAll(SELECTORS.mobile).forEach((drawer) => {
      if (drawer.open && drawer._ssMobilePanel) {
        drawer._ssMobilePanel.style.setProperty('--ss-mobile-menu-top', `${getHeaderBottom()}px`);
      }
    });
  }, { passive: true });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
